import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wActs from "../actions/website-actions";
import {FormattedMessage} from 'react-intl'
import * as wConsts from "../consts/website-consts";
import {Link} from "react-router-dom";
import SwBanner from "../components/swbanner";
import BuyAdBanner from "../components/buyadbanner";
class Login extends Component {



  constructor(props) {
    super(props);
    this.state = {
      Username: "", Password: "", RememberMe: false,

    };
  }

  componentDidMount() {
    //this.props.pageHandler('home');
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "login" });
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  handleSubmit(evt) {
    let dta = this.state;
    dta.FailText = this.getTranslation("response.wrongloginorpassword")
    dta.SuccessText = this.getTranslation("response.loginsuccessful")
    this.props.dispatch(wActs.loginNow(this.state));
  }

  handleRegister(e) {
    $.fancybox().close();
    return false;
  }

  getSignup() {
    return wActs.getCultPath(this.props.WebPage, "/signup");
  }
  getForgot() {
    return wActs.getCultPath(this.props.WebPage, "/reset-password");
  }

  handlePress(evt) {
    if(evt.key === 'Enter') {
      this.handleSubmit(evt);
    }
  }
  handleChange(evt) {
    const target = evt.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    })
  }

  handleErrorClose(evt) {
    this.props.dispatch(wActs.clearLoginError());
  }

  PopupCenter(url, title, w, h) {
    const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(url, title, 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }

    return newWindow;
  }


  handleENewsClick(evt) {
    evt.preventDefault();
    $.fancybox.close();
    this.PopupCenter("https://auth.escortnews.eu/auth/login", "loginWindow", 410, 515);
    window.addEventListener("message", function (event) {
      //if (event.origin.toLowerCase().indexOf("oauth") > 0) {
        if (event.data.token_type === "Bearer") {
          let domain = "." + wActs.getSubdomain(window.location.hostname);
          wActs.setCookie("auth", event.data.access_token, { path: "/", maxAge: 31557600, domain: domain });
          window.location = "/";
        }
      //} else {
      //  console.log("Bad Origin", event);
      //}
    }, false);
  }


  render() {
    let status = this.props.WebPage.User.LoginStatus;
    let centerBan = "four-center-banner" + wActs.MainLeftStyle(this.props.WebPage);
    return (
      <div className={`main`}>
        <div className="inner">
          <div className="container" style={{marginBottom: "200px"}}>

            <div className="title">
              <div className="h2">
                {wActs.getTranslation(this.props.WebPage.Translations,"page.header.login")}
              </div>
            </div>

            <div className="descr-block">
              {wActs.getTranslation(this.props.WebPage.Translations,"page.login.donthaveanaccount")} &nbsp;
              <Link className="blue-link" to={this.getSignup()} title="">{wActs.getTranslation(this.props.WebPage.Translations,"page.login.registerhere")}</Link>
            </div>

            <div className="inner-block flex flex--between">
              <div className="content">

                  <div className="input-wrapper">
                    <span className="input-title">Username</span>
                    <div className="input-container">
                      <input onChange={(e) => {this.setState({Username: e.target.value })}} type="text" className="input"/>
										<span className="ico">
											<i className="fa fa-user"></i>
										</span>
                    </div>
                  </div>

                  <div className="input-wrapper">
                    <span className="input-title">Password</span>
                    <div className="input-container">
                      <input onChange={(e) => {this.setState({Password: e.target.value })}} type="password" className="input"/>
										<span className="ico">
											<i className="fa fa-lock"></i>
										</span>
                    </div>
                  </div>

                  <div className="form-bottom flex flex--center flex--between">
                    <input onClick={(e)=>{this.handleSubmit(e)}} type="button" className="btn btn--blue" value={wActs.getTranslation(this.props.WebPage.Translations,"page.submit")}/>

                      <Link className="blue-link" to={this.getForgot()} className="grey-link">
                        {wActs.getTranslation(this.props.WebPage.Translations,"page.login.forgotpassword")}
                      </Link>
                  </div>


              </div>

              <aside className="aside">
                <div className="aside__item">
                  <div className="aside__item__top flex flex--center">
                    <div className="ico">
                      <i className="fa fa-heart"></i>
                    </div>

                    <div className="title">
                      <div className="h2">{wActs.getTranslation(this.props.WebPage.Translations,"page.smuglist.sexworkers")}</div>
                    </div>
                  </div>

                  <p className="text">
                    {wActs.getTranslation(this.props.WebPage.Translations,"page.smuglist.sexworkers.text1")}
                  </p>
                </div>
              </aside>
            </div>

          </div>
        </div>


      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Login);
